module.exports = __webpack_public_path__ + "img/e4c39ad.png";